import { styled } from '@/stitches.config';

import { Box } from '@base-app';

export const StyledSectionContainer = styled(Box, {
  backgroundColor: '$white',
  borderRadius: '$8',
  boxShadow: '$studyInsights$shadowBox',
  padding: '$6',
});

export const StyledSectionTitle = styled(Box, {
  alignItems: 'flex-start',
  color: '$darkBlue300',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '$xl',
  fontWeight: '$bold',
  marginBottom: '$5',
  maxHeight: '$10',
});
